import Head from 'next/head'
import 'regenerator-runtime/runtime'
import BlogFooter from '../components/blog/Footer'
import { DEFAULT_SUB_MENU, ROUTES } from '../constants/navigation'
import { withHeaderOptions } from '../hoc/withHeaderOptions'
import { getPrerenderedExploreInspirations } from '../queries/posts'
import Explore from '../routes/Explore'
import { addRouteType, addSecondaryMenu } from '../utils/navigation'

const ExplorePage = ({ initialData }) => {
  const inspirations = initialData?.result?.userInspirations || []
  const formatDesignImage = design =>
    design?.image ||
    design?.designThumbnail ||
    design?.cfImageUrl ||
    design?.cfThumbImageUrl ||
    design?.thumbImageFile?.url ||
    design?.feedImageFile?.url ||
    design?.cfBgImageUrl ||
    undefined

  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'DecorMatters',
    url: 'https://decormatters.com',
    logo: 'https://decormatters.com/logo192.png',
    sameAs: [
      'https://www.facebook.com/decormattersapp',
      'https://www.instagram.com/decormattersapp',
    ]
  }

  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: 'Interior Design Ideas & Home Decor Inspiration',
    description: 'Explore thousands of interior design ideas and home decor styles created by real users in the DecorMatters app.',
    url: 'https://decormatters.com/explore',
    mainEntity: organizationSchema
  }

  return (
    <>
      <Head>
        <title>Interior Design Ideas & Home Decor Inspiration | DecorMatters</title>
        <meta name="description" content="Explore thousands of interior design ideas and home decor styles created by real users in the DecorMatters app. Find bedroom ideas, kitchen styles, and cozy living room designs." />
        <meta name="twitter:title" content="Interior Design Ideas & Home Decor Inspiration | DecorMatters" />
        <meta property="og:title" content="Interior Design Ideas & Home Decor Inspiration | DecorMatters" />
        <meta property="og:description" content="Explore thousands of interior design ideas and home decor styles created by real users in the DecorMatters app. Find bedroom ideas, kitchen styles, and cozy living room designs." />
        <meta property="og:site_name" content="DecorMatters" />
        <meta property="og:type" content="website" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://decormatters.com/explore" />
      </Head>
      <Explore initialData={initialData} />
      <BlogFooter />
    </>
  )
}

export default withHeaderOptions(ExplorePage)(addSecondaryMenu(DEFAULT_SUB_MENU), addRouteType(ROUTES.EXPLORE))

export async function getStaticProps() {
  try {
    // Pre-render 60 designs for SEO and fast initial load
    const initialData = await getPrerenderedExploreInspirations('numLikes', 65)

    return {
      props: {
        initialData
      },
      // Regenerate the page every week to keep content fresh
      revalidate: 604800 // 7 days
    }
  } catch (error) {
    console.error('Failed to fetch explore data:', error)

    return {
      props: {
        initialData: null
      },
      revalidate: 300 // Retry in 5 minutes if there was an error
    }
  }
}
